import React from "react";
import distortionLogo from "../../images/logo11.png";
import ralogo from "../../images/ralogo.jpeg";

function Work() {
  const openInNewTab = (url) => {
    const newWindow = window.open(url, "_blank", "noopener,noreferrer");
    if (newWindow) newWindow.opener = null;
  };
  return (
    <>
      <div id="work" className="work">
        <div className="work-title-container">
          <p className="main-title ourWork">
            WORK<span className="dot">.</span>
          </p>
        </div>
        <div className="work-content-container">
          <div className="work-head">
            <p className="live">LIVE</p>
            <p className="work-content-title">Our Projects</p>
          </div>
          <div className="work-body">
            <div className="work-box-container">
              <div
                className="work-box one"
                onClick={() => openInNewTab("https://www.distortion.pro")}
              >
                <img className="dist-logo" src={distortionLogo} alt="" />
              </div>
              <p className="work-box-title">
                distortion.pro{" "}
                <span className="temp-cost" style={{ fontSize: "12px" }}>
                  August 2022
                </span>
              </p>
            </div>
            <div className="work-box-container">
              <div
                className="work-box two"
                onClick={() => openInNewTab("https://rowlandsassociates.com/")}
              >
                <img className="ra-logo" src={ralogo} alt="" />
              </div>
              <p className="work-box-title">
                Rowlands Associates Inc. <br />
                <span className="temp-cost" style={{ fontSize: "12px" }}>
                  March 2023
                </span>
              </p>
            </div>
            <div className="work-box-container">
              <div className="work-box three"></div>
              <p className="work-box-title">
                Interium{" "}
                <span className="temp-cost" style={{ fontSize: "12px" }}>
                  In Progress
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Work;
